import { c as r } from "../../../../index.esm-BeDSGXP5.js";
import { css as n } from "styled-components";
const l = {
  variant: ({ type: o, theme: a }) => /* @__PURE__ */ n([
    "color:",
    ";"
  ], a.componentColors.infoPanel.variants[o]),
  panelBackground: ({ theme: o }) => /* @__PURE__ */ n([
    "",
    ""
  ], r({
    backgroundColor: o.componentColors.infoPanel.background,
    padding: "sm"
  }))
};
export {
  l as default
};
